import PropTypes from 'prop-types'

import Button from '../../../../../shared_components/mui_base_components/button/Button'
import NewContact from '../shared/NewContact'

import './addressBookHeader.scss'

const AddressBookHeader = props => (
  <div className='address-book-header flex-container'>
    {
      props.showContactModal &&
      (
        <NewContact
          context='address_book'
          hideContactModal={props.hideContactModal}
          params={props.params}
        />
      )

    }
    <h1 className='flex-child'>Address Book</h1>
    <div className='add-new-contact flex-child'>
      <Button onClick={props.addNewContact}>Add new</Button>
    </div>
  </div>
)

AddressBookHeader.propTypes = {
  params: PropTypes.object,
  showContactModal: PropTypes.bool,
  hideContactModal: PropTypes.func,
  addNewContact: PropTypes.func
}

export default AddressBookHeader
